<template><div>

<div v-if="cur && squares" id="field" class="ma-5" :style=" 'height:' + cur.height*30 + 'px; width:' +  cur.width*30 + 'px' ">

	<div :class="{pointer: input_mode}" @click="make_active(word)" v-for="(word,index) in Object.keys(squares)" :key="index">
		<transition-group name="cell" tag="div">
		<div class="box" :class="{ active_box: active_word == word }" :style="box_style(word)" :key="word + '-box'"> </div>
		<div class="word_num" :style="squares[word][0].style" :key="word + '-number'"> {{ indexes[word] }} </div>
		<div
			:class="{ active: active_word == word, correct: highlight_correct && word == input_words[word] }"
			class="square" v-for="(sq,index) in squares[word]" :style="sq.style" :key="word + '.' + index">
			{{ input_mode ? input_words[word][index] : word[index] }}
		</div>
		</transition-group>
	</div>

</div>

<input
	@keydown.enter="active_word = null"
	:maxlength="active_word ? active_word.length : 1"
	autocapitalize="off" autocomplete="off" spellcheck="false" autocorrect="off"
	@blur="active_word = null"
	class="invis" ref="invis_input"
	:style="squares[active_word] ? squares[active_word][0].style : ''"
	v-model="input_words[active_word]"
	@input="handle_input"
>


<div v-if="controls">

<p> We have generated {{crosswords.length}} possible crosswords </p>

<p> Showing crossword #{{i}} </p>

<v-slider
	:max="this.crosswords.length-1"
	min="0"
	v-model="i"
></v-slider>

<v-btn @click="i--"> Previous </v-btn>
<v-btn @click="i++"> Next </v-btn>

<v-switch v-model="input_mode" label="User input mode">  </v-switch>

</div>

</div></template>

<script>
// <p v-for="q in get_nums"> {{ q }} </p>
function comp(field) {
	return function(a,b) {
		return a[field] > b[field] ? 1 : a[field] < b[field] ? -1 : 0;
	}
}


// 'left: ' + s.x*size + 'px; top: ' + s.y*size + 'px' 
// 	@compositionupdate="input_words[active_word] = event.data;"

import Crossword from '@/crossword.js'
// 	
//<div class="square" v-for="(s,index) in squares" :key="index" :style="s.style"> {{s.letter}} </div>

export default {
	props: {
		words: Array,
		controls: Boolean,
		highlight_correct: Boolean,
		limit: Number
	},
	components: {},
	data() {
		return {
			i: null,
			//squares: {},
			input_mode: true,
			input_words: {},
			active_word: null,
			indexes: {},
			//crosswords: null,
		}
	},
	watch: {
		/*
		i(newval, oldval) {
			let cur = this.crosswords[newval];
			//if (cur === null) return;

			this.squares = cur.calc_squares();

			//this.input_words = {};
			this.indexes = {};
			let k = 1;

			let p = cur.words_with_the_same_beginning;

			for (let j=0; j < p.length; j+=2 ) {
				this.indexes[ p[j] ] = k;
				this.indexes[ p[j+1] ] = k;
				k++;
			}

			for (let w of this.words) {
				//this.$set(this.input_words, w, '');

				if (!p.includes(w) ) {
					this.indexes[w] = k;
					k++;
				}
			}

			this.$emit('change_indexes', this.get_nums);
		}
		*/
	},
	methods: {
		make_active(word) {
			if (this.input_mode) {
				this.active_word = word;
				this.$refs.invis_input.focus();
			}
		},
		handle_input(event) {
			this.input_words[this.active_word] = event.target.value;

			for (let w in this.input_words) {
				if (w != this.input_words[w]) return;
			}

			this.$emit('win');
			this.input_mode = false;
		},
		box_style(word) {
			let w = 1, h = 1;
			if (this.cur.position[word].direction == 'v') h = word.length;
			else w = word.length;

			return this.squares[word][0].style + '; position: absolute; width: ' +  (30*w+2) + 'px; height: ' + (30*h+2) + 'px';
		}
	},
	
	created() {
		/*
		this.crosswords = new Crossword(...this.words);
		console.log('this.crosswords: ', this.crosswords);
		if (this.crosswords.length == 0) {
			this.$emit('fail');
			return;
		}
		//let C = new Crossword(['joimit']);
		//let all_cws = [];
		//this.crosswords = C[0].add_the_rest(['kalai', 'mabai'], all_cws, 1);
		this.i = 0;
		

		this.input_words = {};
		for (let w of this.words) {
			this.$set(this.input_words, w, '');
		}*/
	},
	
	computed: {
		cur() {
			if (this.crosswords.length == 0) return null;
			return this.crosswords[this.i];
		},
		get_nums() {
			let res = [];
			for (let word in this.indexes) {
				res.push({num: this.indexes[word], word});
			}
			res = res.sort(comp('num'));

			for (let w of res) {
				if (this.cur.words_with_the_same_beginning.includes(w.word)) w.num += this.cur.position[w.word].direction;
			}
			
			return res;
		},
		crosswords() {
			let res = new Crossword(...this.words);
			if (res.length == 0) {
				this.$emit('fail');
			}

			this.i = 0;

			this.input_words = {};
			for (let w of this.words) {
				this.$set(this.input_words, w, '');
			}

			return res;
		},
		squares() {
			if (!this.cur) return [];
			let res = this.cur.calc_squares();

			//this.input_words = {};
			this.indexes = {};
			let k = 1;

			let p = this.cur.words_with_the_same_beginning;

			for (let j=0; j < p.length; j+=2 ) {
				this.indexes[ p[j] ] = k;
				this.indexes[ p[j+1] ] = k;
				k++;
			}

			for (let w of this.words) {
				//this.$set(this.input_words, w, '');

				if (!p.includes(w) ) {
					this.indexes[w] = k;
					k++;
				}
			}

			this.$emit('change_indexes', this.get_nums);
			return res;
		}
	}
}
</script>

<style scoped>

#field {
	position: relative;
	xfont-family: Georgia;
	font-weight: bold;
}

.square {
	user-select: none;
	box-sizing: content-box;
	padding: 1px;
	display: flex;
	width: 26px;
	height: 26px;
	border: 2px solid black;
	position: absolute;
	align-items: center;
	justify-content: center;
	font-size: 23px;
}

.active {
	z-index: 2;
	background: #ffffffc0;
}

.active_box {
	box-shadow: 0 4px 8px 0 blue, 0 6px 20px 0 blue;
}

.box {
	box-sizing: content-box;
	display: flex;
	position: absolute;
	z-index: 3;
}

.correct {
	background: #b3fcc1 !important;
}

.cell-move {
	transition: transform 0.3s;
}

.invis {
	z-index: -2;
	position: absolute;
}

.word_num {
	user-select: none;
	padding-left: 3px;
	display: flex;
	width: 26px;
	height: 26px;
	position: absolute;
	font-size: 23px;
	font-size: 10px;
	z-index: 3;
}

.pointer {
	cursor: pointer;
}

.active_box {
    -webkit-animation: active_box 2s ease-out;
    -webkit-animation-iteration-count: infinite; 
    opacity: 0.5;
}

@-webkit-keyframes active_box {
    0% { 
        opacity: 0.2;
    }
    50% { 
        opacity: 1.0;
    }
    100% { 
        opacity: 0.2;
    }
}


</style>